import { pathSubscription } from 'nike-re-framejs';

export const tournamentsReady$ = pathSubscription(['tournaments', 'tournaments', 'ready']);
export const tournamentsActive$ = pathSubscription(['tournaments', 'tournaments', 'active']);
export const tournamentsFinished$ = pathSubscription(['tournaments', 'tournaments', 'finished']);
export const unseenTournamentCount$ = pathSubscription(['tournaments', 'availableCounts', 'unseen']);
export const activeTournamentCount$ = pathSubscription(['tournaments', 'availableCounts', 'active']);
export const rewards$ = pathSubscription(['tournaments', 'rewards']);
export const tickets$ = id => pathSubscription(['tournaments', 'tickets', id]);
export const ticketsFilter$ = pathSubscription(['tournaments', 'tickets', 'filter']);
export const ticketsCount$ = id => pathSubscription(['tournaments', 'ticketCounts', id]);
export const tournament$$ = id => pathSubscription(['tournaments', 'tournaments', 'byIds', id]);
export const tournamentRanking$$ = id => pathSubscription(['tournaments', 'tournaments', 'rankings', id]);
export const disabledTournaments$ = pathSubscription(['tournaments', 'disabled']);
